import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/breadcrumbs/Breadcrumb';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_SESSIONS_ENTITY } from 'routes/RouteList';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import { useSessionContext } from 'contexts/SessionContext';
import Badge from 'components/badge/Badge';
import ContextMenuWrapper from 'components/menu/ContextMenuWrapper';
import ContextMenu from 'components/menu/ContextMenu';
import {
  ActionButton,
  PanelSubtitle,
  PanelTitle,
  PanelTitleButton,
  PanelTitleButtonsGroup,
  PanelTitleWrapper,
  RefactoredPanelHeader
} from 'components/panel';

const SessionHeader = ({ title, subtitle, isExpired }) => {
  const { push } = useHistory();
  const { entityId } = useParams();
  const { session } = useSessionContext();

  return (
    <>
      <Breadcrumbs>
        <Breadcrumb
          onClick={() =>
            push(generatePath(ROUTE_SESSIONS_ENTITY, { entityId }))
          }
        >
          <FormattedMessage {...messages.breadcrumbSessions} />
        </Breadcrumb>
        <Breadcrumb>
          <FormattedMessage
            {...messages.breadcrumbSession}
            values={{ session: session.name }}
          />
        </Breadcrumb>
      </Breadcrumbs>
      <RefactoredPanelHeader>
        <PanelTitleWrapper>
          <PanelTitle>
            <div>
              {isExpired && session.recurring && (
                <Badge
                  variant="badge-neutral"
                  extraClassNames="u-margin-right-small"
                >
                  <FormattedMessage {...messages.badgeSessionEnded} />
                </Badge>
              )}
              {title}
            </div>
          </PanelTitle>
          <PanelSubtitle
            extraClassNames={
              session.isRecurring ? '.c-panel__subtitle-capitalized' : ''
            }
          >
            {subtitle}
          </PanelSubtitle>
        </PanelTitleWrapper>
        <PanelTitleButtonsGroup>
          <ActionButton />
          <ContextMenuWrapper trigger={<PanelTitleButton />}>
            <ContextMenu />
          </ContextMenuWrapper>
        </PanelTitleButtonsGroup>
      </RefactoredPanelHeader>
    </>
  );
};

export default SessionHeader;
